import React from 'react';
import styled from 'styled-components';

import { Typography } from '@material-ui/core';

import IconScalecube from '../../../assets/scalecube.png';
import IconScalebloc from '../../../assets/scalebloc.png';

const Root = styled.div`
	max-width: 700px;

	h3 {
		margin-bottom: 40px;
		font-size: 20px;
		font-weight: bold;
	}

	h6 {
		font-size: 16px;
		font-weight: bold;
	}

	p {
		margin-top: 20px;
		font-size: 14px;
	}

	img {
		width: 100%;
		height: auto;
		max-width: 250px;
		margin: 0 5%;
	}

	.modal-content {
		display: flex;
		align-items: center;
		margin: 40px 0 0 0;
	}
`;

const IhrOptimiertesSystem = ({ isStoragePark = true }) => (
	<Root>
		<Typography variant="h3">Ihr optimiertes System</Typography>
		<Typography>
			Stationäre Stromspeicher erfahren in den letzten Jahren ein starkes Wachstum.
			2019 folgte, nach unserem Großspeicher INTILION | scalecube, unser erster
			skalierbarer Gewerbespeicher INTILION | scalebloc.
		</Typography>
		{isStoragePark ? (
			<div className="modal-content">
				<img src={IconScalecube} alt="scalecube" />
				<div className="modal-text">
					<Typography variant="h6">
						Ihre passende Systemkomponente ist scalecube
					</Typography>
					<Typography>
						Unser Hochleistungs-Lithium-Ionen Großspeicher bietet Ihnen eine
						sichere Energieversorgung. Durch den modularen Aufbau wird er in
						einer Vielzahl von Anwendungen eingesetzt. Gemeinsam mit Ihnen
						projektieren wir Ihren individuellen{' '}
						<strong>INTILION | scalecube</strong>: Immer die beste Lösung aus
						wirtschaftlicher und technischer Sicht.
					</Typography>
				</div>
			</div>
		) : (
			<div className="modal-content">
				<img src={IconScalebloc} alt="scalebloc" />
				<div className="modal-text">
					<Typography variant="h6">
						Ihre passende Systemkomponente ist scalebloc
					</Typography>
					<Typography>
						Der <strong>INTILION | scalebloc</strong> basiert auf einem
						Lithium-Ionen Batteriesystem und dient als vollumfängliche
						Komplettlösung zur stationären Energiespeicherung. Neben den
						vielfältigen Einsatzmöglichkeiten in den Bereichen
						Eigenbedarfsoptimierung, Peak Shaving, Unterstützung von
						E-Ladesäulen und als additive Notstromlösung im Off-Grid Sektor,
						birgt der Gewerbespeicher noch weitere Highlights.
					</Typography>
				</div>
			</div>
		)}
	</Root>
);

export default IhrOptimiertesSystem;
